import React, { Component, Fragment } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { Field, SubmissionError, reduxForm, getFormValues } from 'redux-form';
import { _t } from "../util/Translator";
import ReCAPTCHA from "react-google-recaptcha";
import * as AfeFields from "../components/AfeFields";
import * as Actions from "../actions";
import store from "../store";

const recaptchaRef = React.createRef();

class JobViewScreen extends Component {
  state = {};

  componentDidMount() {
    console.log("match", this.props);

    store.dispatch(Actions.getJob(this.props.match.params.id));
  }

  onSubmit = async (formValues) => {

    try {
      let result = await store.dispatch(Actions.addCandidate(this.props.match.params.id, formValues));

      this.setState({ isLoading: false });

      this.props.history.push('/jobs/' + this.props.match.params.id + '/create-confirmed');

    } catch (error) {
      this.setState({ isLoading: false });

      const errorMessage = (error.response && error.response.data && error.response.data.error_description) ?
        error.response.data.error_description : "Something went wrong!, " + error.message;

      throw new SubmissionError({ _error: errorMessage });
    }

  }

  getTitleText = (text) => {
    if (text == null) return "";
    // return text != null && text.length > 80 ? text.substring(0, 80).toUpperCase() : text.toUpperCase();
    return text != null && text.substring(0, 80);
  }

  getSalaryText = (salarioMinimo, salarioMaximo) => {
    if (salarioMinimo != null && salarioMaximo != null)
      return salarioMinimo + " - " + salarioMaximo;
    if (salarioMinimo == null && salarioMaximo == null)
      return _t("jobView.competitivo");
    if (salarioMinimo != null)
      return _t("jobView.desde") + " " + salarioMinimo + " €";
    if (salarioMaximo != null)
      return _t("jobView.hasta") + " " + salarioMaximo + " €";
  }

  render() {
    const { handleSubmit, submitting, error, jobDetail } = this.props;

    console.log("El error reportado es:", error);

    return (
      <Fragment>
        <div className="container zero-text-hanken zero-container">
          <div className="row border-bottom pl-0 pb-4 my-5 ">
            <div className="section-marker">
              <div className="section-marker-title ml-lg-0 pl-lg-0 zero-text-medium zero-text-color-primary zero-text-40">{_t("jobView.title")}</div>
            </div>
          </div>
          <div className="row mb-4">
            <div className="col-12 col-lg-6 pl-lg-0 mb-5">
              <div className="card mb-4 zero-shadow-card">
                {jobDetail &&
                  <div className="card-body md-p-10">
                    <h6 className="card-title zero-text-25 zero-text-semi zero-text-color-primary"><strong>{this.getTitleText(jobDetail.publishedTitle)}</strong></h6>
                    <p className="card-text zero-text-regular zero-text-18" style={{ whiteSpace: "pre-line" }}>{jobDetail.publishedText}</p>
                    <div className="d-flex">
                      <p className="card-text zero-text-regular zero-text-18 mb-0 mr-4"><i className="fas fa-map-marker-alt zero-text-color-primary"></i>  {jobDetail.provincia.name}</p>
                      <p className="card-text zero-text-regular zero-text-18 mb-0"><i className="fas fa-euro-sign zero-text-color-primary"></i> {this.getSalaryText(jobDetail.salarioMinimo, jobDetail.salarioMaximo)}</p>
                    </div>
                  </div>
                }
              </div>
              <div className="card mb-4 zero-shadow-card">
                {jobDetail &&
                  <div className="card-body md-p-10">
                    <h5 className="card-title zero-text-25 zero-text-semi zero-text-color-primary"><strong>{_t("jobView.condiciones")}</strong></h5>
                    <p className="card-text zero-text-regular zero-text-18" style={{ whiteSpace: "pre-line" }}>{jobDetail.publishedConditions}</p>
                  </div>
                }
              </div>
              <Link className="btn btn-primary zero-btn zero-text-regular" to={"/jobs/"}>{_t("jobView.listado")}</Link>
            </div>
            <div className="col-12 col-lg-6 pr-lg-0">
              <div className="card zero-shadow-card">
                <div className="card-body md-p-10">
                  {error && <div className="alert alert-danger" role="alert">{error}</div>}
                  <form onSubmit={handleSubmit(this.onSubmit)}>
                    <div className="row">
                      <div className="card-title"><h2 className=" col-12 zero-text-25 zero-text-semi zero-text-color-primary mb-3">{_t("jobView.formTitle")}</h2></div>
                    </div>
                    <div className="row">
                      <div className="col-md-12 mb-2">
                        <Field name="nombre" type="text" component={AfeFields.Input} placeholder={_t("jobView.nombre")} />
                        <Field name="apellidos" type="text" component={AfeFields.Input} placeholder={_t("jobView.apellidos")} />
                        <Field name="email1" type="text" component={AfeFields.Input} placeholder={_t("jobView.email")} />
                        <Field name="telefono1" type="text" component={AfeFields.Input} placeholder={_t("jobView.phone")} />
                        <Field name="cv" component={AfeFields.File} placeholder={_t("jobView.attachFile")} />
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-12 ml-4 zero-text-regular zero-text-18 zero-privacy-policy">
                        <Field name="politicaDePrivacidad" type="checkbox" component={AfeFields.Checkbox}>
                          {_t("home.contactAcceptTermsText")}&nbsp;
                          <Link to="/home/politicaDePrivacidad">{_t("footer.privacyPolicy")}</Link>&nbsp;/&nbsp;
                          <Link to="/home/terminosYCondiciones">{_t("footer.termsAndConditions")}</Link>&nbsp;/&nbsp;
                          <Link to="/home/proteccionDeDatos">{_t("footer.dataProtection")}</Link>
                        </Field>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-12 mb-4">
                        <Field name="recaptcha" type="hidden" component={AfeFields.Input} />
                        <ReCAPTCHA
                          name="recaptcha"
                          ref={recaptchaRef}
                          sitekey="6LdGfcwUAAAAAKA-dcK1A7m_q4MoVnPMVaNXDvg4"
                        />
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-12">
                        <button type="submit" className="btn btn-primary font-default-normal w-100 zero-height-56" disabled={submitting}>{_t("jobView.inscribirse")}</button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>

            </div>

          </div>

        </div>
      </Fragment>
    );
  }
}

const validate = values => {
  const errors = {};
  if (!values.nombre) {
    errors.nombre = 'Required';
  }
  if (!values.apellidos) {
    errors.apellidos = 'Required';
  }
  if (!values.email1) {
    errors.email1 = 'Required';
  }
  if (!values.telefono1) {
    errors.telefono1 = 'Required';
  }
  if (!values.cv) {
    errors.cv = 'Required';
  }
  if (!values.politicaDePrivacidad) {
    errors.politicaDePrivacidad = 'You must check this field';
  }

  const recaptchaValue = (recaptchaRef != null && recaptchaRef.current != null) ? recaptchaRef.current.getValue() : null;

  //console.log("recaptchaValue", recaptchaValue);

  /*
  if (recaptchaValue != null && recaptchaValue != "") {
    //console.log(formValues);
  } else {
    errors.recaptcha = 'Make sure you are not a robot';
  }*/

  return errors;
}

const warn = values => {
  const warnings = {}
  return warnings;
}

const form = reduxForm({
  form: 'jobViewScreen', // a unique identifier for this form
  validate, // <--- validation function given to redux-form
  warn // <--- warning function given to redux-form
})(JobViewScreen);

const mapStateToProps = (state, ownProps) => {
  //console.log("jobDetail", state.jobDetail);

  return {
    initialValues: {},
    enableReinitialize: true,
    jobDetail: state.jobDetail,
    formValues: getFormValues('jobViewScreen')(state)
  };
};

export default connect(mapStateToProps, {})(form);
